import { create } from "zustand";

interface ModalsState {
  isOrderDetailsOpen: boolean;
  isCartModalOpen: boolean;
  actions: {
    setIsOrderDetailsOpen: (isOrderDetailsOpen: boolean) => void;
    setIsCartModalOpen: (isCartModalOpen: boolean) => void;
  };
}

const useModalsStore = create<ModalsState>()((set) => ({
  isOrderDetailsOpen: false,
  isCartModalOpen: false,
  actions: {
    setIsOrderDetailsOpen: (isOrderDetailsOpen: boolean) =>
      set({ isOrderDetailsOpen }),
    setIsCartModalOpen: (isCartModalOpen: boolean) =>
      set({ isCartModalOpen }),
  },
}));

export const useIsOrderDetailsOpen = (): boolean =>
  useModalsStore((state) => state.isOrderDetailsOpen);

export const useIsCartModalOpen = (): boolean =>
  useModalsStore((state) => state.isCartModalOpen);

export const useModalsActions = (): ModalsState["actions"] =>
  useModalsStore((state) => state.actions);
